import { Typography } from '@mui/material';
import React, { FC } from 'react';
import MUIDownloadFile from '../form-fields/fields/MUIDownloadFile';
import { useApplication } from '../../../../context/ApplicationContext';
import { cloneDeep } from 'lodash';

import { get } from 'lodash';
import PutRecord from '../../../../lib/api/PutRecord';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { set } from 'lodash';
import { STRAPI_URL } from '../../../../lib/constants/url';
import { getUserJwt } from '../../../../context/AuthHelper';

interface BescheidDownloadProps {
	bescheidPath: string;
	bescheidDownloadOnPath: string;
	bescheidDownloadStrapiFieldName: string;
	apiName: string;
	apiObjectId: number;
	statischeVorlagenPath?: string;
	externesSchreibensPath?: string;
	extraFilesPath?: string;
}
const BescheidDownload: FC<BescheidDownloadProps> = ({
	bescheidPath,
	bescheidDownloadOnPath,
	bescheidDownloadStrapiFieldName,
	apiName,
	apiObjectId,
	statischeVorlagenPath = '',
	externesSchreibensPath = '',
	extraFilesPath = '',
}) => {
	const { application, saveApplication } = useApplication();

	console.log({ statischeVorlagenPath, externesSchreibensPath, extraFilesPath });

	const updateBescheidDownloadedOnField = async () => {
		let appCopy = cloneDeep(application);
		if (get(appCopy, bescheidDownloadOnPath, '') === null || get(appCopy, bescheidDownloadOnPath, '') === '') {
			set(appCopy, bescheidDownloadStrapiFieldName, new Date());

			try {
				await PutRecord(apiName, apiObjectId, { data: { [bescheidDownloadStrapiFieldName]: new Date() } });
				await PostRecord(APIS.PushNotificaiton, { data: { entities: [{ api: apiName, id: apiObjectId }] } });
				saveApplication(false, appCopy);
			} catch (err: any) {
				console.error('ERROR: Update Bescheid heruntergeladen am ', err);
			}
		}
		await fetchFile(get(appCopy, `${bescheidPath}.attributes.url`), get(appCopy, `${bescheidPath}.attributes.name`));
	};

	const fetchFile = async (url: string, fileName: string = '') => {
		try {
			let res = await fetch(`${STRAPI_URL}${url}`, {
				headers: {
					Authorization: `Bearer ${getUserJwt()}`,
				},
			});

			const blob = await res.blob();
			const objectUrl = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(objectUrl);
		} catch (err: any) {
			console.error(' ERROR: Downloading File ', err);
		}
	};
	return (
		<>
			<Typography>Hier können Sie Ihren Bescheid herunterladen</Typography>
			<MUIDownloadFile
				fileMetaData={get(application, bescheidPath, {})}
				onDownload={updateBescheidDownloadedOnField}
				downloadedOn={get(application, bescheidDownloadOnPath, null)}
				showDownloadButton={true}
			/>
		</>
	);
};

export default BescheidDownload;
